import { CalendarClock } from 'lucide-react';
import { MAINT } from '../lib/maint';

const KEYS = ['ok', 'warn', 'defect', 'none', 'due'];

export default function MaintFilter({ t, value, onChange }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="chip-group maint-filter" data-testid="maint-filter" title={t.mtFilter}>
      {KEYS.map((k) => (
        <button key={k} className={`chip seg mf-btn ${value.includes(k) ? 'on' : ''}`} data-testid={`maint-filter-${k}`} title={t['mt_' + k]} onClick={() => toggle(k)}>
          {k === 'due' ? <CalendarClock size={13} /> : <i className="mf-dot" style={{ background: MAINT[k] || 'transparent' }} />}
        </button>
      ))}
      {value.length > 0 && <button className="chip seg" data-testid="maint-filter-clear" onClick={() => onChange([])}>×</button>}
    </div>
  );
}
